import { IconArchive, IconCloud, IconHardDrive } from '@frameio/vapor-icons';

export const StandardStorageIcon = IconCloud;
export const MountedStorageIcon = IconHardDrive;
export const ArchivedStorageIcon = IconArchive;
